import { useEffect } from "react";

// Lightweight SEO helper — updates document.title and meta tags per page without adding deps.
const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}='${name}']`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector("link[rel='canonical']");
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setJsonLd = (id, data) => {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  if (!data) return;
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.id = id;
  s.text = JSON.stringify(data);
  document.head.appendChild(s);
};

const SEO = ({ title, description, image, jsonLd }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} — KASHiX` : "KASHiX · Where Devotion Becomes Power";
    document.title = fullTitle;
    const desc =
      description ||
      "KASHiX — independent Indian artist creating original devotional music: Sanskrit chants, cinematic bhajans and aggressive bhakti.";
    const img =
      image ||
      "https://images.unsplash.com/photo-1768843883385-11ded8a0d016?w=1200&q=80";
    const url = window.location.href;

    setMeta("description", desc);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:image", img, "property");
    setMeta("og:url", url, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", img);
    setCanonical(url);
    setJsonLd("kx-jsonld", jsonLd || null);

    return () => setJsonLd("kx-jsonld", null);
  }, [title, description, image, jsonLd]);

  return null;
};

export default SEO;
